module.exports = __webpack_public_path__ + "static/img/周少文B.3d9c399f.png";